export default __webpack_public_path__ + "static/Parachute_Canada_final-309dc8614315488ae48dc3ed643c9ec7.mp4";